<template>
    <default-item class="valentines-day_food_item--container" :item="item" :pricing-types="pricingTypes"
                  :layout="priceLayout"></default-item>
</template>

<script lang="ts">
/**
 * Custom component for Bimini food items.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.0.3
 * @copyright  Copyright (C) 2025-2026, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 * @changelog
 *    2025-02-10 (1.0.0) (jhoward)
 *      - <thanksgivingFoodItem> copied to <valentinesDayFoodItem>.
 *
 *    2025-04-08 (1.0.1) (jhoward)
 *      - Remove "visual_" prefix from class names in <valentinesDayFoodItem>.
 *
 * 2026-02-06 (1.0.2) (jhoward)
 *   - Adjust .valentines-day_food_item--container .menu--tag top position from 1em to -1.5em for improved layout.
 *
 * 2026-07-20 (1.0.3) (jhoward)
 *   - Update App\Library\Js\Components\Menu\Item\ValentinesDay_foodItem.vue to adjust .menu--tag positioning and add mobile-specific styles.
 */

import {defineComponent, PropType} from "vue";
import {MenuItem} from "../defs";
import DefaultItem from "./defaultItem.vue";

export default defineComponent({
  name: 'valentines-day-food-item',
  components: {
    DefaultItem
  },
  props: {
    item: {
      type: Object as PropType<MenuItem>,
      required: true
    },
    pricingTypes: {
      type: Array as PropType<string[]>,
      default: () => []
    },
    priceLayout: {
      type: String as PropType<'price-inline' | 'price-below'>,
      default: 'price-inline'
    }
  },
})
</script>

<style scoped>
.valentines-day_food_item--container {
  text-align: center;
}

.valentines-day_food_item--container:deep(.menu--item_title) {
  font-weight: normal;
}

.valentines-day_food_item--container:deep(.menu--tag) {
  position: absolute;
  right: 0;
  top: -1.5em;
  width: 4em;
  height: 4em;
}

@media screen and (max-width: 760px) {
  .valentines-day_food_item--container:deep(.menu--tag) {
    display: none;
  }
}
</style>